import { isCompanyAdmin, isCompanyEmployee } from './planAccess';

/**
 * Whether the task has at least one assignee/claimer (list or detail shapes).
 */
export function isTaskClaimedOrAssigned(task) {
  if (!task) {
    return false;
  }
  const hasAssignedUsers = Array.isArray(task.assigned_users) && task.assigned_users.length > 0;
  const hasAssignedNames = Boolean(task.assigned_user_names && String(task.assigned_user_names).trim());
  const hasAssignments = Array.isArray(task.assignments) && task.assignments.length > 0;
  return hasAssignedUsers || hasAssignedNames || hasAssignments;
}

/**
 * Short assignee/claimer label for cards (first assignee).
 */
export function getTaskAssigneeLabel(task) {
  if (!task) {
    return null;
  }
  if (Array.isArray(task.assigned_users) && task.assigned_users.length > 0) {
    const assignedUser = task.assigned_users[0];
    const first = assignedUser.firstName || '';
    const lastInitial = assignedUser.lastName ? `${assignedUser.lastName[0]}.` : '';
    const short = [first, lastInitial].filter(Boolean).join(' ');
    if (short) {
      return short;
    }
  }
  const names = (task.assigned_user_names || '').trim();
  return names || null;
}

/**
 * Whether the current user may claim this task (list or detail shapes).
 * Upcoming (future scheduled) tasks are claimable.
 */
export function canClaimTask(user, task) {
  if (!user || !task || task.status !== 'pending') {
    return false;
  }
  if (!(isCompanyAdmin(user) || isCompanyEmployee(user))) {
    return false;
  }

  return !isTaskClaimedOrAssigned(task);
}
